module.exports = __webpack_public_path__ + "static/media/main-landing.3bcd8c04.png";